import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

interface ComicCardProps {
  id: number;
  title: string;
  author: string;
  category: string;
  rating: number;
  views: number;
  status: string;
  coverUrl: string;
  updateDate: string;
}

export default function ComicCard({
  id,
  title,
  author,
  category,
  rating,
  views,
  status,
  coverUrl,
  updateDate,
}: ComicCardProps) {
  const categoryInfo = categories.find((c) => c.slug === category);

  const formatViews = (v: number) => {
    if (v >= 10000) return (v / 10000).toFixed(1) + '万';
    return v.toString();
  };

  return (
    <Link
      to={`/article/${id}`}
      className="group block bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-200 transition-all duration-300 overflow-hidden cursor-pointer"
    >
      <div className="relative aspect-[3/4] overflow-hidden">
        <img
          src={coverUrl}
          alt={title}
          title={`${title} - 高清韩国漫画`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-2 left-2">
          <span className="px-2 py-0.5 bg-primary-500 text-background-50 text-xs rounded-md font-medium">
            {rating}
          </span>
        </div>
        {status === '已完结' && (
          <div className="absolute top-2 right-2">
            <span className="px-2 py-0.5 bg-accent-500 text-background-50 text-xs rounded-md font-medium">
              完结
            </span>
          </div>
        )}
      </div>
      <div className="p-3">
        <h3 className="text-sm font-semibold text-foreground-900 truncate group-hover:text-primary-600 transition-colors">
          {title}
        </h3>
        <div className="flex items-center gap-2 mt-1.5">
          {categoryInfo && (
            <span className="text-xs text-secondary-600 bg-secondary-100 px-2 py-0.5 rounded-full whitespace-nowrap">
              {categoryInfo.name}
            </span>
          )}
          <span className="text-xs text-foreground-500">{author}</span>
        </div>
        <div className="flex items-center justify-between mt-2">
          <div className="flex items-center gap-1 text-xs text-foreground-500">
            <div className="w-3 h-3 flex items-center justify-center">
              <i className="ri-eye-line text-[10px]"></i>
            </div>
            <span>{formatViews(views)}</span>
          </div>
          <span className="text-xs text-foreground-400">{updateDate}</span>
        </div>
      </div>
    </Link>
  );
}